import http from './axiosTwo';

// let normalUrl = 'api'; //env环境
// window.normalUrl = 'api'; //nev环境
// let userState = 'userState';
let normalUrl = '/doublecarbon'; //线上域名
window.normalUrl = '/doublecarbon'; //线上域名
let userState = 'https://user.drcnet.com.cn/userapi'; //上线前放开
// //
export default {
	//首页
	//获取导航数据
	// getheaderdata() {·
	// 	return http('get', normalUrl + '/index/getIndexTitle', 'json');
	// },
	//获取导航数据-新
	getheaderdata() {
		return http('get', normalUrl + '/index/getNavigationBarList', 'json');
	},
	//热门关键字
	getHotWordsList() {
		return http('get', normalUrl + '/index/getHotWordsList', 'json');
	},
	//根据Uid获取栏目下的文章列表
	getDocList(data) {
		return http('post', normalUrl + '/index/getDocList', 'json', data);
	},
	//根据日期获取碳排放交易数据地区
	getRegionTransactionData(data) {
		return http(
			'post',
			normalUrl + '/index/getRegionTransactionData',
			'json',
			data
		);
	},
	//根据日期获取碳排放交易数据全国-k线图
	getNationTransactionData(searchYear) {
		return http(
			'get',
			normalUrl +
				'/index/getNationTransactionData?searchYear=' +
				searchYear,
			'json'
		);
	},
	//首页第一屏--获取美国，欧盟或者英国的碳排放交易折线图数据
	getSomeTransactionLineData(countryType) {
		return http(
			'get',
			normalUrl +
				'/index/getSomeTransactionLineData?countryType=' +
				countryType
		);
	},
	//首页四个横条图
	getCarbonPracticeData(cityType) {
		return http(
			'get',
			normalUrl + '/index/getCarbonPracticeData?cityType=' + cityType
		);
	},

	//获取碳排放交易年份
	getYears() {
		return http('get', normalUrl + '/index/getDateYearList', 'json');
	},
	//获取二级页栏目列表
	getNavList(uid) {
		return http(
			'get',
			normalUrl + '/second/getSecondTitle?id=' + uid,
			'json'
		);
	},
	//二级页面-学术论文文章列表查询
	getAcademicDocList(data) {
		return http(
			'post2',
			normalUrl + '/second/getAcademicDocList',
			'aaaa',
			data
		);
	},
	//二级页面-学术论文左侧菜单列表查询
	getAcademicMenus(id) {
		return http(
			'get',
			normalUrl + '/second/getAcademicMenus?id=' + id,
			'json'
		);
	},
	//二级页面-动态资讯标签信息列表获取
	getDynamicInfoTagsList(id) {
		return http(
			'get',
			normalUrl + '/second/getDynamicInfoTagsList',
			'json'
		);
	},
	//二级页面-行动方案左侧菜单
	getMenuList(id) {
		return http('get', normalUrl + '/plan/getMenuList', 'json');
	},
	//首页-实践案例-双碳实践-柱状菱形图数据获取
	getSecondPracticeData(id) {
		return http(
			'get',
			normalUrl + '/plan/getSecondPracticeData?regionId=' + id,
			'json'
		);
	},
	//行动方案-获取重点任务列表
	getTaskList(id) {
		return http('get', normalUrl + '/plan/getTaskList', 'json');
	},

	//二级页面-行动方案右侧详情内容（1-2块）
	getBasicInfos(regionId) {
		return http(
			'get',
			normalUrl + '/plan/getBasicInfos?regionId=' + regionId,
			'json'
		);
	},
	//二级页面-行动方案右侧echarts
	getGraphicData(data) {
		return http('get2', normalUrl + '/plan/getGraphicData', 'aaa', data);
	},

	//获取二级页栏目列表之--能源数据
	getNavList2(uid) {
		return http(
			'get',
			normalUrl + '/energy/getSecondTitle?type=' + uid + '',
			'json'
		);
	},
	//获取二级页栏目列表之--碳交易
	getNavList3(uid) {
		return http(
			'get',
			normalUrl + '/transac/getSecondTitle?type=' + uid + '',
			'json'
		);
	},
	//获取二级页栏目列表之--碳排放
	getNavList4(uid) {
		return http(
			'get',
			normalUrl + '/discharge/getSecondTitle?type=' + uid + '',
			'json'
		);
	},
	//获取二级页栏目列表之--六大栏目的第二栏目列表
	getNavList5(uid) {
		return http(
			'get',
			normalUrl + '/second/getThreeTitle?id=' + uid + '',
			'json'
		);
	},
	//根据Uid获取二级页面右侧的文章列表
	getarticleList(data) {
		return http('post', normalUrl + '/second/getDocList', 'json', data);
	},
	//根据日期获取碳排放交易数据-改名了-getRegionTransactionData
	// getTransactionData(data) {
	// 	return http(
	// 		'post',
	// 		normalUrl + '/index/getTransactionData',
	// 		'json',
	// 		data
	// 	);
	// },
	//二级页面碳排放数据显示--显示饼图-左
	getTransactionData2(data) {
		return http(
			'post',
			normalUrl + '/second/getTransactionData',
			'json',
			data
		);
	},
	//二级页面碳排放数据显示--显示饼图-右
	getTransactionData3(data) {
		return http(
			'post',
			normalUrl + '/second/getTransactionData2',
			'json',
			data
		);
	},
	//获取二级页面碳排放量数据时间轴list
	getDates() {
		return http('get', normalUrl + '/second/getDates', 'json');
	},
	//获取国际概览地区列表
	getAreaData(id) {
		return http('get', normalUrl + '/second/getArea?id=' + id, 'json');
	},
	//能源数据-获取表格数据
	getGraphListData(data) {
		return http(
			'post',
			normalUrl + '/energy/getGraphListData',
			'json',
			data
		);
	},
	//能源数据-获取表格数据-平衡表数据
	getBalanceDataList(data) {
		return http(
			'post',
			normalUrl + '/energy/getBalanceDataList',
			'json',
			data
		);
	},

	//能源平衡表-根据indexId获取能源平衡表indicator维度列表-指标
	getIndicatorList(id) {
		return http(
			'get',
			normalUrl + '/energy/getIndicatorList?indexId=' + id,
			'json'
		);
	},
	//能源平衡表-根据indexId获取能源平衡表product维度列表-产品
	getProductList(id) {
		return http(
			'get',
			normalUrl + '/energy/getProductList?indexId=' + id,
			'json'
		);
	},
	//能源平衡表-根据indexId获取能源平衡表provice维度列表
	getProviceList(id) {
		return http(
			'get',
			normalUrl + '/energy/getProviceList?indexId=' + id,
			'json'
		);
	},
	//交易数据-获取表格数据
	getGraphListData2(data) {
		return http(
			'post',
			normalUrl + '/transac/getGraphListData',
			'json',
			data
		);
	},
	//碳排放-获取表格数据
	getGraphListData3(data) {
		return http(
			'post',
			normalUrl + '/discharge/getGraphListData',
			'json',
			data
		);
	},
	//绿色债券-获取表格数据
	getGraphListData4(data) {
		return http('post', normalUrl + '/green/getBondListData', 'json', data);
	},
	//公募基金-获取表格数据
	getGraphListData5(data) {
		return http(
			'post',
			normalUrl + '/green/getPublicFundData',
			'json',
			data
		);
	},
	//私募基金-获取表格数据
	getGraphListData6(data) {
		return http(
			'post',
			normalUrl + '/green/getPrivateFundData',
			'json',
			data
		);
	},
	//碳金融产品-碳债券-获取表格数据
	getGraphListData7(data) {
		return http(
			'post',
			normalUrl + '/carbon/getBondListData',
			'json',
			data
		);
	},
	//ESG产品-ESG债券-获取表格数据
	getGraphListData8(data) {
		return http('post', normalUrl + '/esg/getBondListData', 'json', data);
	},
	//ESG产品-ESG债券-获取表格数据
	getGraphListData9(data) {
		return http('post', normalUrl + '/carbon/getFundData', 'json', data);
	},
	//ESG产品-ESG基金-获取表格数据
	getGraphListData10(data) {
		return http('post', normalUrl + '/esg/getFundData', 'json', data);
	},
	//绿色信托-获取表格数据
	getGraphListData11(data) {
		return http(
			'post',
			normalUrl + '/green/getTrustInfoData',
			'json',
			data
		);
	},
	//绿色债券-按债券类型统计债券期数
	getStatisticDataByType(data) {
		return http(
			'post',
			normalUrl + '/green/getStatisticDataByType',
			'json',
			data
		);
	},
	//碳金融产品-碳债券-按债券类型统计债券期数
	getStatisticDataByType2(data) {
		return http(
			'post',
			normalUrl + '/carbon/getStatisticDataByType',
			'json',
			data
		);
	},
	//ESG产品-ESG债券-按债券类型统计债券期数
	getStatisticDataByType3(data) {
		return http(
			'post',
			normalUrl + '/esg/getStatisticDataByType',
			'json',
			data
		);
	},
	//绿色债券-按债券期限统计债券期数
	getStatisticDataByDate(data) {
		return http(
			'post',
			normalUrl + '/green/getStatisticDataByDate',
			'json',
			data
		);
	},
	//碳金融产品-碳债券-按债券期限统计债券期数
	getStatisticDataByDate2(data) {
		return http(
			'post',
			normalUrl + '/carbon/getStatisticDataByDate',
			'json',
			data
		);
	},
	//ESG产品-ESG债券-按债券期限统计债券期数
	getStatisticDataByDate3(data) {
		return http(
			'post',
			normalUrl + '/esg/getStatisticDataByDate',
			'json',
			data
		);
	},
	//绿色债券-按发行地区统计债券发行规模
	getStatisticDataByRegion(data) {
		return http(
			'post',
			normalUrl + '/green/getStatisticDataByRegion',
			'json',
			data
		);
	},
	//碳金融产品-碳债券-按发行地区统计债券发行规模
	getStatisticDataByRegion2(data) {
		return http(
			'post',
			normalUrl + '/carbon/getStatisticDataByRegion',
			'json',
			data
		);
	},
	//ESG产品-ESG债券-按发行地区统计债券发行规模
	getStatisticDataByRegion3(data) {
		return http(
			'post',
			normalUrl + '/esg/getStatisticDataByRegion',
			'json',
			data
		);
	},
	//绿色债券-按行业分类统计债券发行规模
	getStatisticDataByIndustry(data) {
		return http(
			'post',
			normalUrl + '/green/getStatisticDataByIndustry',
			'json',
			data
		);
	},
	//碳金融产品-碳债券-按行业分类统计债券发行规模
	getStatisticDataByIndustry2(data) {
		return http(
			'post',
			normalUrl + '/carbon/getStatisticDataByIndustry',
			'json',
			data
		);
	},
	//ESG产品-ESG债券-按行业分类统计债券发行规模
	getStatisticDataByIndustry3(data) {
		return http(
			'post',
			normalUrl + '/esg/getStatisticDataByIndustry',
			'json',
			data
		);
	},
	//公募基金-按基金类型统计基金数量
	getPublicFundByType(data) {
		return http(
			'post',
			normalUrl + '/green/getPublicFundByType',
			'json',
			data
		);
	},
	//碳金融产品-碳基金-按基金类型统计基金数量
	getPublicFundByType2(data) {
		return http('post', normalUrl + '/carbon/getFundByType', 'json', data);
	},
	//ESG产品-ESG基金-按基金类型统计基金数量
	getPublicFundByType3(data) {
		return http('post', normalUrl + '/esg/getFundByType', 'json', data);
	},
	//按产品登记年份统计产品数量
	getPublicFundByType4(data) {
		return http(
			'post',
			normalUrl + '/green/getDataByRegisterDate',
			'json',
			data
		);
	},
	//私募基金-按基金类型统计基金数量
	getPrivateFundByType(data) {
		return http(
			'post',
			normalUrl + '/green/getPrivateFundByType',
			'json',
			data
		);
	},
	//公募基金-按发行年份统计资产规模
	getPublicFundByYear(data) {
		return http(
			'post',
			normalUrl + '/green/getPublicFundByYear',
			'json',
			data
		);
	},
	//碳金融产品-碳基金-按发行年份统计资产规模
	getPublicFundByYear2(data) {
		return http('post', normalUrl + '/carbon/getFundByYear', 'json', data);
	},
	//ESG产品-ESG基金-按发行年份统计资产规模
	getPublicFundByYear3(data) {
		return http('post', normalUrl + '/esg/getFundByYear', 'json', data);
	},
	//绿色信托-按主要投向行业统计产品数量
	getPublicFundByYear4(data) {
		return http(
			'post',
			normalUrl + '/green/getDataByMainSector',
			'json',
			data
		);
	},
	//私募基金-按发行年份统计资产规模
	getPrivateFundByYear(data) {
		return http(
			'post',
			normalUrl + '/green/getPrivateFundByYear',
			'json',
			data
		);
	},
	//环境责任险-按保险公司统计产品数量
	getInsuranceByName(data) {
		return http(
			'post',
			normalUrl + '/green/getInsuranceByName',
			'json',
			data
		);
	},
	//环境责任险-按销售地区统计产品数量
	getInsuranceByArea(data) {
		return http(
			'post',
			normalUrl + '/green/getInsuranceByArea',
			'json',
			data
		);
	},
	//环境责任险-列表数据
	getInsuranceData(data) {
		return http(
			'post',
			normalUrl + '/green/getInsuranceData',
			'json',
			data
		);
	},
	//绿色信贷-列表数据
	getTrustYearData(data) {
		return http(
			'post',
			normalUrl + '/green/getTrustYearData',
			'json',
			data
		);
	},
	//二级页-获取福接单菜单
	getMenu(_id) {
		return http('get', normalUrl + '/second/getMenu?id=' + _id, 'json');
	},
	//能源数据-获取地区列表
	getRegionList(type) {
		return http(
			'get',
			normalUrl + '/energy/getRegionList?type=' + type,
			'json'
		);
	},
	//能源数据-获取中国地图数据
	getGraphMapData(data) {
		return http(
			'post',
			normalUrl + '/energy/getGraphMapData',
			'json',
			data
		);
	},
	//碳排放-获取中国地图数据
	getGraphMapData2(data) {
		return http(
			'post',
			normalUrl + '/discharge/getGraphMapData',
			'json',
			data
		);
	},
	//能源数据-获取中国地图->柱状图
	getGraphBarMapData(data) {
		return http(
			'post',
			normalUrl + '/energy/getGraphBarMapData',
			'json',
			data
		);
	},
	//排放数据-获取中国地图->柱状图
	getGraphBarMapData2(data) {
		return http(
			'post',
			normalUrl + '/discharge/getGraphBarMapData',
			'json',
			data
		);
	},
	//能源数据-获取俩柱状图
	getGraphData(data) {
		return http('post', normalUrl + '/energy/getGraphData', 'json', data);
	},
	//交易数据-获取俩柱状图
	getGraphData2(data) {
		return http(
			'post',
			normalUrl + '/transac/getGraphBarData',
			'json',
			data
		);
	},
	//能源数据-获取全国能源概览数据
	getGeneralViewData(type) {
		return http(
			'get',
			normalUrl + '/energy/getGeneralViewData?type=' + type,
			'json'
		);
	},
	//获取证监会行业分类-碳金融
	getIndustryData(data) {
		return http(
			'post',
			normalUrl + '/carbon/getIndustryData',
			'json',
			data
		);
	},
	//获取证监会行业分类-绿色金融
	getIndustryData2(data) {
		return http('post', normalUrl + '/green/getIndustryData', 'json', data);
	},
	//获取证监会行业分类-esg
	getIndustryData3(data) {
		return http('post', normalUrl + '/esg/getIndustryData', 'json', data);
	},
	//首页统计查询
	getIndexStatistics(type) {
		return http('get', normalUrl + '/index/getIndexStatistics', 'json');
	},
	//获取专题列表
	getTopListByChnIdAndYear(data) {
		return http(
			'post',
			normalUrl + '/index/getTopListByChnIdAndYear',
			'json',
			data
		);
	},
	//获取专题列表年份
	getYearListByChnId(data) {
		return http(
			'post',
			normalUrl + '/index/getYearListByChnId',
			'json',
			data
		);
	},
	//专题详情页导航
	getLeafByChnId(chnid) {
		return http(
			'get',
			normalUrl + '/index/getLeafByChnId?chnid=' + chnid,
			'json'
		);
	},
	//专题详情页专题背景文章
	getSpecialTopicFine(chnid) {
		return http(
			'get',
			normalUrl + '/index/getSpecialTopicFine?chnid=' + chnid,
			'json'
		);
	},
	//专题详情页专题背景图片，导读，title
	getSpecialTopicDetail(chnid) {
		return http(
			'get',
			normalUrl + '/index/getSpecialTopicDetail?chnid=' + chnid,
			'json'
		);
	},
	//根据LeafID获取栏目下的文章列表
	getDocListByLeafId(data) {
		return http(
			'post',
			normalUrl + '/index/getDocListByLeafId',
			'json',
			data
		);
	},
	//判断是否已登录
	// iflogin(guid) {
	//     return http('get', userState + '/loginController/initLogin?guid=' + guid, 'json');
	// },
	iflogin(guid) {
		return http(
			'get',
			userState +
				'/loginController/initLoginP?callback=showData&guid=' +
				guid,
			'json'
		);
	},
	unlogin(guid) {
		//退出登录
		return http('get', normalUrl + '/login/loginOut?guid=' + guid, 'json');
	},
	weighterRights(productId) {
		//判断是否有权限
		return http(
			'get',
			normalUrl + '/authority/getAuthor?productId=' + productId,
			'json'
		);
	},
	//获取5周年-按标签统计文章数-行业聚焦， docIndexTypeId = 90 地方行动，docIndexTypeId=46
	getDocCountByTagAndYear(uid, year, docIndexTypeId) {
		return http(
			'get',
			`https://www.drcnet.com.cn/reportapi/CommonController/common/docCountByTagAndYear?uid=${uid}&year=${year}&docIndexTypeId=${docIndexTypeId}`,
			'json'
		);
	},
	//专题详情页专题背景文章
	getInfoTagsListByType(type) {
		return http(
			'get',
			normalUrl + '/second/getInfoTagsListByType?type=' + type,
			'json'
		);
	},
};

// $.ajax({
//     url: 'http://user.drcnet.com.cn/userapi/loginController/initLoginP',
//     // url: 'https://user.drcnet.com.cn/userapi/loginController/initLogin?flag=init',
//     type: 'get',
//     responseType: 'application/json',
//     dataType: 'jsonp',
//     jsonpCallback: 'showData',
//     xhrFields: {
//         withCredentials: true
//     },
//     success: function (data) {
//         if (data.Logined === 0) {
//             if (to.path === '/' || to.path === '/guide' || to.path === '/intro') {
//                 // //console.log('无权限')
//                 next()
//             } else if (to.path === '/lit/channel' || to.path === '/lit/channel2') {
//                 // //console.log('无权限')
//                 next()
//             } else {
//                 // //console.log('有权限')
//                 let skipUrl = window.location.origin + '/#' + to.fullPath
//                 let url = 'http://d.drcnet.com.cn/eDRCnet.common.web/login/login.aspx'
//                 let loginUrl = url + '?gourl=' + skipUrl.replace('?', '~~').replace('&', '^')
//                 window.location.href = loginUrl
//             }
//         } else {
//             setName(data.UserName)
//             setToken(data.UserToken)
//             next()
//         }
//     }
// })



// WEBPACK FOOTER //
// ./static/common/api/api.js